import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Research from "./pages/Research";
import Notes from "./pages/Notes";
import Reviews from "./pages/Reviews";
import NondeterministicTimeHierarchy from "./pages/NondeterministicTimeHierarchy";
import HowWrong from "./pages/BlogEntries/HowWrong";
import Hitch from "./pages/BlogEntries/Hitch";
import Eden from "./pages/Reviews/Eden";
import Brave from "./pages/Reviews/Brave";
import Sea from "./pages/Reviews/Sea";
import Road from "./pages/Reviews/Road";
import Cradle from "./pages/Reviews/Cradle";
import Eyre from "./pages/Reviews/Eyre";
import TheSea from "./pages/Reviews/TheSea";
import Sun from "./pages/Reviews/Sun";
import WarPeace from "./pages/Reviews/WarPeace";
import Shining from "./pages/Reviews/Shining";
import Prince from "./pages/Reviews/Prince";
import Finn from "./pages/Reviews/Finn";
import Sirens from "./pages/Reviews/Sirens";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/research" element={<Research />} />
          <Route path="/blog" element={<Notes />} />
          <Route path="/blog/nondeterministic-time-hierarchy" element={<NondeterministicTimeHierarchy />} />
          <Route path="/book-reviews" element={<Reviews />} />
          <Route path="/notes" element={<Navigate to="/blog" replace />} />
          <Route path="/reading" element={<Navigate to="/book-reviews" replace />} />
          <Route path="/publications" element={<Navigate to="/research" replace />} />
          <Route path="/howWrong" element={<HowWrong />} />
          <Route path="/eden" element={<Eden />} />
          <Route path="/brave" element={<Brave />} />
          <Route path="/sea" element={<Sea />} />
          <Route path="/warpeace" element={<WarPeace />} />
          <Route path="/road" element={<Road />} />
          <Route path="/shining" element={<Shining />} />
          <Route path="/hitch" element={<Hitch />} />
          <Route path="/cradle" element={<Cradle />} />
          <Route path="/eyre" element={<Eyre />} />
          <Route path="/thesea" element={<TheSea />} />
          <Route path="/sun" element={<Sun />} />
          <Route path="/prince" element={<Prince />} />
          <Route path="/finn" element={<Finn />} />
          <Route path="/sirens" element={<Sirens />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
